module.exports = __webpack_public_path__ + "assets/img/lpbao_01.eb5711f8.jpg";